import { useMutation, useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { get, post, API_URL } from 'lib/network/api';

const getInvoiceErrorMessage = (error) => {
  if (typeof error === 'string') return error;

  if (error?.message) return error.message;

  if (typeof error?.detail === 'string') return error.detail;
  if (error?.detail?.message) return error.detail.message;

  if (error?.response?.data?.message) return error.response.data.message;
  if (typeof error?.response?.data?.detail === 'string') return error.response.data.detail;

  return 'Failed to create invoice. Please try again.';
};

const getApiErrorMessage = (error) => {
  if (typeof error === 'string') return error;

  if (error?.message) return error.message;

  if (typeof error?.detail === 'string') return error.detail;
  if (error?.detail?.message) return error.detail.message;

  if (error?.response?.data?.message) return error.response.data.message;
  if (typeof error?.response?.data?.detail === 'string') return error.response.data.detail;

  return '';
};

export function useCreateInvoiceMutation() {
  return useMutation({
    mutationFn: async (payload) => {
      const res = await post(`${API_URL}/api/invoice`, payload);
      return res;
    },
    onSuccess: () => {
      toast.success('Invoice created!');
    },
    onError: (error) => {
      toast.error(getInvoiceErrorMessage(error));
    },
  });
}

export function useCreateDoitpayVAMutation(options = {}) {
  return useMutation({
    mutationFn: async (payload) => {
      const res = await post(`${API_URL}/payment/doitpay/va/create`, payload);
      return res;
    },
    ...options,
  });
}

export function useInvoiceStatusQuery(invoiceNumber, options = {}) {
  return useQuery({
    queryKey: ['invoice-status', invoiceNumber],
    queryFn: async () => {
      return await get(`${API_URL}/api/invoice/${invoiceNumber}`);
    },
    enabled: Boolean(invoiceNumber),
    ...options,
  });
}

export function useGetBalanceData(options = {}) {
  return useQuery({
    queryKey: ['balance-data'],
    queryFn: async () => {
      try {
        return await get(`${API_URL}/api/user/dana/balance`);
      } catch (error) {
        const message = getApiErrorMessage(error);

        if (message === 'DANA account is not bound') {
          return {
            isDanaNotBound: true,
            message,
            data: null,
          };
        }

        throw error;
      }
    },
    ...options,
  });
}

export function useUnbindDanaMutation(options = {}) {
  return useMutation({
    mutationFn: async () => {
      return await post(`${API_URL}/api/user/dana/unbind`, {});
    },
    ...options,
  });
}
